import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const WrapContext = React.createContext([{ modifiers: [] }, _.noop]);

const WrapProvider = ({ children }) => {
	const [state, setState] = useState({ modifiers: [] });

	return (
		<WrapContext.Provider value={[state, setState]}>
			{children}
		</WrapContext.Provider>
	);
};

WrapProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export { WrapContext, WrapProvider };
